var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path0, _path1, _path10, _ellipse2, _path11, _path12, _path13, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _ellipse7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 235,
    viewBox: "0 0 389 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.67 111.56C121.183 111.56 124.94 114.703 124.94 120.99C124.94 127.277 121.183 130.42 113.67 130.42H98.95V153.19C98.95 157.023 97.8767 160.013 95.73 162.16C93.5834 164.153 90.7467 165.15 87.22 165.15C83.8467 165.15 81.0867 164.153 78.94 162.16C76.7933 160.013 75.72 157.023 75.72 153.19V130.42H11.09C7.71668 130.42 5.11001 129.5 3.27001 127.66C1.43001 125.82 0.51001 123.443 0.51001 120.53C0.51001 117.463 1.50668 114.473 3.50001 111.56L76.87 5.98998C79.3233 2.46332 82.7733 0.699982 87.22 0.699982C90.44 0.699982 93.2 1.77332 95.5 3.91998C97.8 5.91332 98.95 8.82665 98.95 12.66V111.56H113.67ZM26.04 111.56H75.72V39.8L26.04 111.56Z",
    fill: "#B4D1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M377.49 111.56C385.004 111.56 388.76 114.703 388.76 120.99C388.76 127.277 385.004 130.42 377.49 130.42H362.77V153.19C362.77 157.023 361.697 160.013 359.55 162.16C357.404 164.153 354.567 165.15 351.04 165.15C347.667 165.15 344.907 164.153 342.76 162.16C340.614 160.013 339.54 157.023 339.54 153.19V130.42H274.91C271.537 130.42 268.93 129.5 267.09 127.66C265.25 125.82 264.33 123.443 264.33 120.53C264.33 117.463 265.327 114.473 267.32 111.56L340.69 5.98998C343.144 2.46332 346.594 0.699982 351.04 0.699982C354.26 0.699982 357.02 1.77332 359.32 3.91998C361.62 5.91332 362.77 8.82665 362.77 12.66V111.56H377.49ZM289.86 111.56H339.54V39.8L289.86 111.56Z",
    fill: "#B4D1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.91 165.84C176.05 165.84 161.637 158.787 151.67 144.68C141.857 130.573 136.95 110.027 136.95 83.04C136.95 55.9 141.857 35.2766 151.67 21.17C161.637 7.06331 176.05 0.00997925 194.91 0.00997925C213.77 0.00997925 228.107 7.06331 237.92 21.17C247.887 35.1233 252.87 55.67 252.87 82.81C252.87 109.95 247.887 130.573 237.92 144.68C228.107 158.787 213.77 165.84 194.91 165.84Z",
    fill: "#405764"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.226 22.805C170.442 22.4412 170.998 22.5712 171.03 22.993L171.278 26.2291C171.289 26.3697 171.368 26.4963 171.489 26.5683L174.28 28.2257C174.643 28.4418 174.513 28.9976 174.092 29.03L170.856 29.2784C170.715 29.2892 170.588 29.3678 170.516 29.4891L168.859 32.2796C168.643 32.6433 168.087 32.5134 168.055 32.0916L167.806 28.8555C167.795 28.7149 167.717 28.5883 167.596 28.5162L164.805 26.8588C164.441 26.6428 164.571 26.0869 164.993 26.0546L168.229 25.8061C168.37 25.7953 168.496 25.7167 168.568 25.5955L170.226 22.805Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228.742 59.5047C229.03 59.0191 229.773 59.1926 229.816 59.7558L230.147 64.0763C230.162 64.2641 230.267 64.4331 230.429 64.5293L234.154 66.7421C234.64 67.0306 234.467 67.7727 233.903 67.8159L229.583 68.1476C229.395 68.162 229.226 68.267 229.13 68.4289L226.917 72.1545C226.629 72.6402 225.886 72.4667 225.843 71.9035L225.512 67.5829C225.497 67.3952 225.392 67.2262 225.23 67.13L221.505 64.9171C221.019 64.6287 221.192 63.8866 221.756 63.8433L226.076 63.5117C226.264 63.4972 226.433 63.3923 226.529 63.2304L228.742 59.5047Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.122 66.2035C175.238 66.0077 175.538 66.0777 175.555 66.3048L175.689 68.0471C175.695 68.1228 175.737 68.191 175.802 68.2298L177.305 69.1221C177.5 69.2385 177.431 69.5377 177.203 69.5552L175.461 69.6889C175.385 69.6947 175.317 69.737 175.278 69.8023L174.386 71.3048C174.27 71.5006 173.97 71.4306 173.953 71.2035L173.819 69.4612C173.813 69.3855 173.771 69.3173 173.706 69.2785L172.203 68.3862C172.008 68.2699 172.078 67.9706 172.305 67.9532L174.047 67.8194C174.123 67.8136 174.191 67.7713 174.23 67.706L175.122 66.2035Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M205.533 30.016C205.581 29.8522 205.811 29.8478 205.866 30.0097L206.285 31.2515C206.303 31.3054 206.347 31.3472 206.401 31.3633L207.658 31.7345C207.822 31.7829 207.826 32.0134 207.664 32.068L206.423 32.487C206.369 32.5052 206.327 32.5485 206.311 32.6032L205.94 33.8601C205.891 34.0239 205.661 34.0283 205.606 33.8664L205.187 32.6246C205.169 32.5706 205.126 32.5289 205.071 32.5128L203.814 32.1415C203.65 32.0932 203.646 31.8627 203.808 31.8081L205.049 31.3891C205.103 31.3709 205.145 31.3276 205.161 31.2729L205.533 30.016Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.966 93.8426C157.949 93.454 158.442 93.2736 158.679 93.5816L160.502 95.9445C160.581 96.0472 160.706 96.1049 160.835 96.0991L163.817 95.9664C164.205 95.949 164.386 96.442 164.078 96.6796L161.715 98.5023C161.612 98.5815 161.554 98.7058 161.56 98.8354L161.693 101.817C161.71 102.205 161.217 102.386 160.98 102.078L159.157 99.7148C159.078 99.6121 158.953 99.5544 158.824 99.5601L155.842 99.6929C155.454 99.7102 155.274 99.2173 155.582 98.9797L157.944 97.1569C158.047 97.0777 158.105 96.9534 158.099 96.8239L157.966 93.8426Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.757 142.322C215.747 142.094 216.036 141.988 216.175 142.169L217.242 143.552C217.288 143.612 217.361 143.646 217.437 143.643L219.183 143.565C219.41 143.555 219.516 143.844 219.336 143.983L217.952 145.05C217.892 145.096 217.858 145.169 217.861 145.245L217.939 146.991C217.949 147.218 217.661 147.324 217.522 147.144L216.454 145.76C216.408 145.7 216.335 145.666 216.259 145.67L214.514 145.747C214.286 145.757 214.18 145.469 214.361 145.33L215.744 144.262C215.804 144.216 215.838 144.143 215.835 144.067L215.757 142.322Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 50.5,
    r: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 33.5,
    r: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203,
    cy: 79,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 129,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 141,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 76,
    r: 1,
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 207.755,
    cy: 226.725,
    rx: 67.7554,
    ry: 7.89787,
    fill: "url(#paint0_radial)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 199.176,
    y: 143.657,
    width: 4.26051,
    height: 79.4004,
    transform: "rotate(11 199.176 143.657)",
    fill: "#F2F6FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 199.011,
    y: 144.512,
    width: 1.83976,
    height: 78.5289,
    transform: "rotate(11 199.011 144.512)",
    fill: "url(#paint1_linear)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 201.084,
    y: 145.014,
    width: 2.13025,
    height: 78.5289,
    transform: "rotate(11 201.084 145.014)",
    fill: "url(#paint2_linear)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 184.048,
    y: 218.446,
    width: 5.42247,
    height: 6.1971,
    rx: 2.71123,
    transform: "rotate(11 184.048 218.446)",
    fill: "#9DB1BD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 184.201,
    y: 218.673,
    width: 5.03515,
    height: 3.29221,
    rx: 1.64611,
    transform: "rotate(11 184.201 218.673)",
    fill: "url(#paint3_linear)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 183.72,
    y: 221.144,
    width: 5.03515,
    height: 3.29221,
    rx: 1.64611,
    transform: "rotate(11 183.72 221.144)",
    fill: "url(#paint4_linear)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 204.932,
    y: 144.179,
    width: 4.26051,
    height: 79.4004,
    transform: "rotate(-11 204.932 144.179)",
    fill: "#F2F6FE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 205.098,
    y: 145.034,
    width: 1.83976,
    height: 78.5289,
    transform: "rotate(-11 205.098 145.034)",
    fill: "url(#paint5_linear)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 207.209,
    y: 144.724,
    width: 2.13025,
    height: 78.5289,
    transform: "rotate(-11 207.209 144.724)",
    fill: "url(#paint6_linear)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 218.921,
    y: 219.19,
    width: 5.42247,
    height: 6.1971,
    rx: 2.71123,
    transform: "rotate(-11 218.921 219.19)",
    fill: "#9DB1BD"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 219.149,
    y: 219.344,
    width: 5.03515,
    height: 3.29221,
    rx: 1.64611,
    transform: "rotate(-11 219.149 219.344)",
    fill: "url(#paint7_linear)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 219.628,
    y: 221.815,
    width: 5.03515,
    height: 3.29221,
    rx: 1.64611,
    transform: "rotate(-11 219.628 221.815)",
    fill: "url(#paint8_linear)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 202.038,
    y: 145.681,
    width: 4.26051,
    height: 79.4004,
    fill: "#F2F6FE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 202.038,
    y: 146.552,
    width: 1.83976,
    height: 78.5289,
    fill: "url(#paint9_linear)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 204.169,
    y: 146.649,
    width: 2.13025,
    height: 78.5289,
    fill: "url(#paint10_linear)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 201.458,
    y: 221.983,
    width: 5.42247,
    height: 6.1971,
    rx: 2.71123,
    fill: "#9DB1BD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 201.65,
    y: 222.176,
    width: 5.03515,
    height: 3.29221,
    rx: 1.64611,
    fill: "url(#paint11_linear)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 201.65,
    y: 224.694,
    width: 5.03515,
    height: 3.29221,
    rx: 1.64611,
    fill: "url(#paint12_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M207.314 141.517C207.88 141.517 208.41 141.725 208.864 142.087C209.318 141.725 209.847 141.517 210.413 141.517H207.314Z",
    fill: "#9DB1BD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M210.364 145.633C210.364 147.142 209.762 148.462 208.864 149.178C209.318 149.54 209.847 149.748 210.413 149.748C212.097 149.748 213.463 147.905 213.463 145.633C213.463 143.36 212.097 141.517 210.413 141.517C209.847 141.517 209.318 141.725 208.864 142.087C209.762 142.803 210.364 144.123 210.364 145.633Z",
    fill: "#9DB1BD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.314 149.748H210.413C209.847 149.748 209.318 149.54 208.864 149.178C208.41 149.54 207.88 149.748 207.314 149.748Z",
    fill: "#9DB1BD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.314,
    cy: 145.633,
    rx: 3.05014,
    ry: 4.11526,
    fill: "#F2F6FE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.234 138.462C156.999 140.327 157.246 142.369 158.047 144.353C158.848 146.336 160.095 147.99 161.565 149.184L157.234 138.462Z",
    fill: "url(#paint13_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.646 150.831C173.91 149.108 175.603 143.345 173.489 138.114C171.376 132.883 166.191 130.003 161.927 131.726C159.279 132.795 157.618 135.409 157.234 138.462L161.565 149.184C163.974 151.139 166.998 151.9 169.646 150.831Z",
    fill: "url(#paint14_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.489 138.114C175.603 143.345 173.91 149.108 169.646 150.831L266.231 121.583L251.722 85.671L161.927 131.726C166.191 130.003 171.376 132.883 173.489 138.114Z",
    fill: "url(#paint15_linear)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 258.96,
    cy: 103.582,
    rx: 18.1072,
    ry: 22.6097,
    transform: "rotate(-22 258.96 103.582)",
    fill: "#73858F"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.392,
    cy: 105.831,
    rx: 17.3325,
    ry: 21.6414,
    transform: "rotate(-22 253.392 105.831)",
    fill: "#B4D1FF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.707,
    cy: 108.955,
    rx: 13.8951,
    ry: 18.2524,
    transform: "rotate(-22 254.707 108.955)",
    fill: "#CEE1FF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.89,
    cy: 92.4982,
    rx: 2.75965,
    ry: 3.63111,
    transform: "rotate(-22 255.89 92.4982)",
    fill: "#F2F6FE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.697 127.687C279.358 123.38 283.639 109.096 278.261 95.7831C272.882 82.47 259.879 75.1691 249.219 79.4762C238.558 83.7833 234.277 98.0674 239.656 111.381C245.034 124.694 258.037 131.995 268.697 127.687ZM267.428 124.545C276.7 120.799 280.424 108.377 275.747 96.7988C271.069 85.221 259.76 78.8723 250.488 82.6185C241.216 86.3646 237.492 98.7872 242.169 110.365C246.847 121.943 258.156 128.291 267.428 124.545Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.024 87.5089L235.027 87.518C226.84 92.487 223.854 104.581 228.433 115.915C233.012 127.248 243.561 133.874 252.903 131.761L252.906 131.77L265.82 128.562C263.671 129.011 261.465 129.035 259.278 128.677C256.103 128.156 252.968 126.829 250.099 124.823C245.73 121.767 241.981 117.135 239.656 111.38C237.33 105.626 236.81 99.6894 237.83 94.456C238.5 91.0201 239.834 87.8872 241.756 85.3074C242.937 83.7226 244.34 82.3466 245.948 81.2373L235.024 87.5089Z",
    fill: "url(#paint16_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.266 142.433C211.782 142.225 212.276 141.983 212.749 141.711L201.189 137.784L194.805 121.983L198.949 108.33C198.516 108.45 198.087 108.595 197.663 108.766C190.176 111.791 187.152 121.78 190.908 131.077C194.664 140.374 203.779 145.458 211.266 142.433Z",
    fill: "#73858F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.636 112.707C184.292 116.029 181.867 124.992 185.248 133.362C188.591 141.637 196.42 146.385 203.238 144.543C203.671 144.426 204.101 144.282 204.525 144.111C205.096 143.88 205.64 143.606 206.156 143.293C200.022 143.015 193.834 138.327 190.904 131.077C187.975 123.826 189.17 116.155 193.389 111.694C192.801 111.827 192.22 112.008 191.648 112.239C191.301 112.379 190.963 112.536 190.636 112.707Z",
    fill: "url(#paint17_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M204.525 144.111C204.101 144.282 203.671 144.426 203.238 144.543L209.578 142.972C208.454 143.243 207.306 143.345 206.156 143.293C205.64 143.606 205.096 143.88 204.525 144.111Z",
    fill: "url(#paint18_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M190.636 112.707C190.963 112.536 191.301 112.379 191.648 112.239C192.22 112.008 192.801 111.827 193.389 111.694C194.046 111 194.775 110.383 195.574 109.858L190.636 112.707Z",
    fill: "url(#paint19_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.476 133.016C226.95 136.103 224.534 138.534 221.378 139.809C217.466 141.389 213.139 140.903 209.262 138.834L218.057 136.171L228.476 133.016ZM198.68 112.875L206.914 108.652L216.708 103.629C213.43 102.425 209.956 102.337 206.76 103.628C202.808 105.225 200.016 108.634 198.68 112.875Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.646 150.831L168.507 151.176C168.379 151.202 168.252 151.225 168.123 151.244C168.64 151.168 169.149 151.031 169.646 150.831ZM161.927 131.726C161.546 131.879 161.186 132.065 160.847 132.279L161.927 131.726Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M218.057 136.171C212.266 137.369 205.741 133.158 202.937 126.216C200.135 119.283 201.926 111.807 206.914 108.652L198.68 112.875C197.301 117.254 197.474 122.52 199.525 127.595C201.596 132.72 205.179 136.655 209.262 138.834L218.057 136.171Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215.653 140.716C214.991 141.153 214.282 141.527 213.528 141.832C213.128 141.994 212.723 142.132 212.314 142.249L219.271 140.456C218.08 140.711 216.867 140.794 215.653 140.716Z",
    fill: "url(#paint20_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M199.708 107.626C200.462 107.322 201.232 107.098 202.011 106.953C202.831 106.053 203.763 105.268 204.798 104.625L198.825 108.025C199.112 107.881 199.406 107.748 199.708 107.626Z",
    fill: "url(#paint21_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.282 140.195C219.947 140.296 219.61 140.383 219.271 140.456L220.282 140.195ZM213.528 141.832C214.282 141.527 214.991 141.153 215.653 140.716C209.152 140.301 202.634 135.289 199.525 127.595C196.417 119.9 197.623 111.767 202.011 106.953C201.232 107.098 200.462 107.322 199.708 107.626C199.406 107.748 199.112 107.881 198.825 108.025C191.889 111.497 189.217 121.209 192.882 130.279C196.4 138.986 204.53 144.062 211.722 142.402C211.92 142.356 212.117 142.305 212.314 142.249C212.723 142.132 213.128 141.994 213.528 141.832ZM204.798 104.625C205.078 104.451 205.365 104.287 205.66 104.134L204.798 104.625Z",
    fill: "url(#paint22_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M171.802 123.6C172.364 123.373 172.938 123.204 173.518 123.09C174.082 122.486 174.714 121.952 175.408 121.502L170.752 124.102C171.088 123.915 171.439 123.747 171.802 123.6Z",
    fill: "url(#paint23_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.946 148.9C183.45 149.222 182.92 149.499 182.358 149.726C181.994 149.873 181.626 149.995 181.253 150.094L186.409 148.73C185.597 148.888 184.772 148.943 183.946 148.9Z",
    fill: "url(#paint24_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.669 148.397C187.254 148.537 186.833 148.648 186.409 148.73L187.669 148.397ZM180.471 148.157C181.608 148.586 182.778 148.84 183.946 148.9C183.45 149.222 182.92 149.499 182.358 149.726C181.994 149.873 181.626 149.995 181.253 150.094C175.64 151.588 169.22 147.709 166.486 140.943C163.753 134.177 165.676 126.927 170.752 124.102C171.088 123.915 171.439 123.747 171.802 123.6C172.364 123.373 172.938 123.204 173.518 123.09C172.719 123.945 172.054 124.94 171.535 126.039C169.825 129.652 169.684 134.383 171.514 138.912C173.343 143.44 176.732 146.746 180.471 148.157ZM175.408 121.502C175.77 121.267 176.15 121.054 176.546 120.866L175.408 121.502Z",
    fill: "url(#paint25_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.507 151.176L169.646 150.831C169.273 150.982 168.892 151.096 168.507 151.176ZM161.927 131.726L160.847 132.279C161.186 132.065 161.546 131.879 161.927 131.726ZM173.489 138.114C174.24 139.973 174.51 141.899 174.356 143.687C173.213 142.316 172.241 140.71 171.514 138.912C170.79 137.119 170.374 135.295 170.243 133.521C171.594 134.686 172.736 136.251 173.489 138.114Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.214 148.195C190.4 147.312 192.123 145.709 193.298 143.668L185.818 145.934L179.633 147.807C182.414 149.086 185.449 149.312 188.214 148.195ZM173.489 138.114C174.24 139.973 174.51 141.899 174.356 143.687C173.213 142.316 172.241 140.71 171.514 138.912C170.79 137.119 170.374 135.295 170.243 133.521C171.594 134.686 172.736 136.251 173.489 138.114ZM171.124 127.009L176.941 124.025L184.014 120.397C181.71 119.705 179.307 119.733 177.079 120.633C174.27 121.768 172.224 124.092 171.124 127.009Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M185.818 145.934C181.197 146.89 175.996 143.543 173.758 138.005C171.524 132.476 172.962 126.541 176.941 124.025L171.124 127.009C170.383 128.972 170.071 131.204 170.243 133.521C171.594 134.686 172.736 136.251 173.489 138.114C174.24 139.973 174.51 141.899 174.356 143.687C175.874 145.507 177.692 146.914 179.633 147.807L185.818 145.934Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.641 103.433C216.641 103.433 216.641 103.433 216.742 103.628C216.843 103.823 216.843 103.823 216.843 103.823L216.485 104.009C216.256 104.128 215.926 104.3 215.524 104.509C214.719 104.928 213.624 105.497 212.464 106.101C210.144 107.309 207.564 108.653 206.524 109.203C205.543 109.72 203.747 111.553 202.682 114.489C201.623 117.412 201.292 121.419 203.224 126.276C205.014 130.775 208.071 133.371 210.99 134.75C212.451 135.44 213.877 135.824 215.09 135.989C216.309 136.155 217.296 136.097 217.886 135.918C219.15 135.534 221.785 134.738 224.104 134.038C225.264 133.688 226.345 133.362 227.135 133.123L228.426 132.734L228.427 132.734L228.427 132.734C228.427 132.734 228.427 132.734 228.49 132.944C228.554 133.154 228.554 133.154 228.554 133.154L228.553 133.154L228.552 133.155L227.262 133.544C226.471 133.782 225.391 134.108 224.231 134.458C221.912 135.158 219.277 135.954 218.014 136.338C217.34 136.543 216.283 136.595 215.031 136.425C213.775 136.254 212.306 135.856 210.803 135.147C207.795 133.726 204.651 131.052 202.816 126.438C200.844 121.48 201.173 117.362 202.269 114.339C203.361 111.33 205.217 109.396 206.319 108.814C207.361 108.264 209.941 106.919 212.261 105.711C213.421 105.108 214.516 104.538 215.321 104.119C215.723 103.91 216.053 103.739 216.283 103.62L216.64 103.434L216.641 103.433Z",
    fill: "url(#paint26_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.582 119.99C184.582 119.99 184.582 119.99 184.662 120.144C184.742 120.297 184.742 120.297 184.742 120.297L184.459 120.444C184.277 120.538 184.015 120.674 183.697 120.839C183.059 121.17 182.192 121.619 181.273 122.096C179.434 123.05 177.391 124.111 176.566 124.545C175.789 124.954 174.366 126.401 173.523 128.719C172.683 131.027 172.422 134.191 173.952 138.027C175.37 141.58 177.792 143.629 180.105 144.718C181.263 145.263 182.392 145.567 183.353 145.697C184.319 145.828 185.101 145.782 185.568 145.641C186.569 145.337 188.657 144.709 190.495 144.156C191.414 143.88 192.27 143.622 192.896 143.434L193.918 143.127L193.919 143.126L193.92 143.126C193.92 143.126 193.92 143.126 193.97 143.292C194.02 143.458 194.02 143.458 194.02 143.458L194.02 143.458L194.019 143.459L192.997 143.766C192.37 143.954 191.514 144.212 190.595 144.488C188.758 145.041 186.67 145.669 185.669 145.972C185.136 146.134 184.298 146.175 183.307 146.041C182.311 145.906 181.147 145.592 179.957 145.032C177.573 143.91 175.083 141.798 173.629 138.155C172.067 134.24 172.328 130.988 173.196 128.601C174.06 126.225 175.531 124.698 176.404 124.238C177.229 123.804 179.274 122.742 181.112 121.788C182.031 121.312 182.898 120.862 183.536 120.531C183.855 120.366 184.116 120.231 184.298 120.137L184.581 119.99L184.582 119.99Z",
    fill: "url(#paint27_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M201.021 148.586C202.224 148.586 203.2 147.264 203.2 145.633C203.2 144.002 202.224 142.679 201.021 142.679C199.818 142.679 198.843 144.002 198.843 145.633C198.843 147.264 199.818 148.586 201.021 148.586Z",
    fill: "#73858F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M207.315 148.586C206.112 148.586 205.136 147.264 205.136 145.633C205.136 144.002 206.112 142.679 207.315 142.679H201.021C202.224 142.679 203.2 144.002 203.2 145.633C203.2 147.264 202.224 148.586 201.021 148.586H207.315Z",
    fill: "#73858F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M207.315 148.586C208.518 148.586 209.494 147.264 209.494 145.633C209.494 144.002 208.518 142.679 207.315 142.679C206.112 142.679 205.136 144.002 205.136 145.633C205.136 147.264 206.112 148.586 207.315 148.586Z",
    fill: "#73858F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M197.922 141.517C198.488 141.517 199.017 141.725 199.471 142.087C199.926 141.725 200.455 141.517 201.021 141.517H197.922Z",
    fill: "#9DB1BD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M200.972 145.633C200.972 147.142 200.37 148.462 199.471 149.178C199.926 149.54 200.455 149.748 201.021 149.748C202.705 149.748 204.071 147.905 204.071 145.633C204.071 143.36 202.705 141.517 201.021 141.517C200.455 141.517 199.926 141.725 199.471 142.087C200.37 142.803 200.972 144.123 200.972 145.633Z",
    fill: "#9DB1BD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M197.922 149.748H201.021C200.455 149.748 199.926 149.54 199.471 149.178C199.017 149.54 198.488 149.748 197.922 149.748Z",
    fill: "#9DB1BD"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.922,
    cy: 145.633,
    rx: 3.05014,
    ry: 4.11526,
    fill: "#F2F6FE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.755 226.725) rotate(90) scale(7.89787 67.7554)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAC9",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#61799F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 199.011,
    y1: 145.819,
    x2: 200.851,
    y2: 145.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE5F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 203.214,
    y1: 190.524,
    x2: 200.729,
    y2: 190.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 186.719,
    y1: 218.673,
    x2: 186.719,
    y2: 220.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 186.238,
    y1: 224.287,
    x2: 186.238,
    y2: 222.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#718592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CB0BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 205.098,
    y1: 146.341,
    x2: 206.938,
    y2: 146.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE5F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 209.339,
    y1: 190.234,
    x2: 206.854,
    y2: 190.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 221.666,
    y1: 219.344,
    x2: 221.666,
    y2: 220.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 222.145,
    y1: 224.957,
    x2: 222.145,
    y2: 223.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#718592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CB0BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 202.038,
    y1: 147.859,
    x2: 203.878,
    y2: 147.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE5F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 206.299,
    y1: 192.159,
    x2: 203.814,
    y2: 192.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 204.167,
    y1: 222.176,
    x2: 204.167,
    y2: 223.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 204.167,
    y1: 227.837,
    x2: 204.167,
    y2: 226.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#718592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CB0BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 200.827,
    y1: 104.289,
    x2: 217.516,
    y2: 141.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4EAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#F7FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F7FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE3E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 200.827,
    y1: 104.289,
    x2: 217.516,
    y2: 141.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4EAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#F7FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F7FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE3E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 200.827,
    y1: 104.289,
    x2: 217.516,
    y2: 141.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4EAF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#F7FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F7FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE3E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 243.608,
    y1: 81.7432,
    x2: 263.086,
    y2: 129.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C95A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#C5D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 194.832,
    y1: 109.908,
    x2: 208.434,
    y2: 143.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C95A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#C5D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 194.832,
    y1: 109.908,
    x2: 208.434,
    y2: 143.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C95A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#C5D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 194.832,
    y1: 109.908,
    x2: 208.434,
    y2: 143.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C95A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#C5D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 203.439,
    y1: 104.97,
    x2: 218.057,
    y2: 141.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C95A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#C5D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 203.439,
    y1: 104.97,
    x2: 218.057,
    y2: 141.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C95A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#C5D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 203.439,
    y1: 104.97,
    x2: 218.057,
    y2: 141.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C95A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#C5D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 174.565,
    y1: 121.648,
    x2: 185.7,
    y2: 149.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C95A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#C5D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 174.565,
    y1: 121.648,
    x2: 185.7,
    y2: 149.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C95A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#C5D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 174.565,
    y1: 121.648,
    x2: 185.7,
    y2: 149.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C95A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#C5D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#9DB1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 202.692,
    y1: 125.479,
    x2: 216.966,
    y2: 119.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73858F",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73858F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 173.531,
    y1: 137.398,
    x2: 184.83,
    y2: 133.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73858F",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73858F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.717bab3cb0d0d0abab73a13c27141e75.svg";
export { ForwardRef as ReactComponent };